export default "__VITE_ASSET__f3b4397e__"